import styles from './styles.module.scss'

const Tab = () => {
    return <div className={styles['seller']}></div>
}

export default Tab
